
export default function IndustryModules() {
  const industries = [
    {
      title: 'Legal',
      description: 'Never miss a consultation.',
      icon: 'ri-scales-line',
      image: 'https://public.readdy.ai/ai/img_res/8e8f906de22f683635feb4cd0b25f3a8.jpg'
    },
    {
      title: 'Medical',
      description: 'Intelligent scheduling without staff overload.',
      icon: 'ri-heart-pulse-line',
      image: 'https://readdy.ai/api/search-image?query=Modern%20minimalist%20medical%20clinic%20reception%20area%20with%20clean%20white%20surfaces%20and%20soft%20ambient%20lighting%20professional%20healthcare%20environment%20premium%20aesthetic%20shallow%20depth%20of%20field%20cinematic%20photography%20neutral%20tones%20calming%20atmosphere&width=600&height=400&seq=industry-medical-01&orientation=landscape'
    },
    {
      title: 'Real Estate',
      description: 'Respond in seconds. Close faster.',
      icon: 'ri-home-line',
      image: 'https://readdy.ai/api/search-image?query=Modern%20luxury%20real%20estate%20property%20exterior%20at%20golden%20hour%20with%20warm%20soft%20lighting%20clean%20architectural%20lines%20premium%20aesthetic%20shallow%20depth%20of%20field%20cinematic%20photography%20elegant%20sophisticated%20warm%20neutral%20tones&width=600&height=400&seq=industry-realestate-01&orientation=landscape'
    },
    {
      title: 'Service Contractors',
      description: 'Every call becomes an estimate.',
      icon: 'ri-tools-line',
      image: 'https://readdy.ai/api/search-image?query=Modern%20professional%20contractor%20workshop%20with%20organized%20tools%20on%20wall%20clean%20workspace%20soft%20ambient%20lighting%20premium%20aesthetic%20shallow%20depth%20of%20field%20cinematic%20photography%20warm%20neutral%20tones%20professional%20craftsmanship&width=600&height=400&seq=industry-contractor-01&orientation=landscape'
    },
    {
      title: 'Automotive Retail',
      description: 'Service bays stay full.',
      icon: 'ri-car-line',
      image: 'https://readdy.ai/api/search-image?query=Modern%20premium%20automotive%20dealership%20showroom%20with%20sleek%20car%20silhouette%20soft%20dramatic%20lighting%20clean%20minimal%20interior%20premium%20aesthetic%20shallow%20depth%20of%20field%20cinematic%20photography%20dark%20elegant%20tones%20sophisticated&width=600&height=400&seq=industry-auto-01&orientation=landscape'
    }
  ];

  return (
    <section className="bg-white py-28 lg:py-36">
      <div className="container mx-auto px-6 lg:px-12">
        <div className="text-center mb-20">
          <p className="text-sm font-semibold tracking-[0.2em] uppercase text-[#2563EB] mb-4">Industries</p>
          <h2 className="text-4xl lg:text-5xl xl:text-6xl font-bold text-[#0B1C2D] tracking-tight">
            Built for High-Value
            <br />
            Service Businesses
          </h2>
        </div>

        {/* Top row: 3 cards */}
        <div className="grid md:grid-cols-3 gap-6 max-w-6xl mx-auto mb-6">
          {industries.slice(0, 3).map((industry, index) => (
            <div
              key={index}
              className="group rounded-2xl overflow-hidden bg-[#F8FAFC] hover:shadow-xl transition-all duration-500 cursor-pointer"
            >
              <div className="w-full h-52 overflow-hidden">
                <img
                  src={industry.image}
                  alt={industry.title}
                  className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-700"
                />
              </div>
              <div className="p-7">
                <div className="w-10 h-10 flex items-center justify-center mb-4 bg-[#2563EB]/10 rounded-xl">
                  <i className={`${industry.icon} text-xl text-[#2563EB]`}></i>
                </div>
                <h3 className="text-xl font-bold text-[#0B1C2D] mb-2">
                  {industry.title}
                </h3>
                <p className="text-base text-gray-500 leading-relaxed">
                  {industry.description}
                </p>
              </div>
            </div>
          ))}
        </div>

        {/* Bottom row: 2 cards centered */}
        <div className="grid md:grid-cols-2 gap-6 max-w-4xl mx-auto">
          {industries.slice(3).map((industry, index) => (
            <div
              key={index + 3}
              className="group rounded-2xl overflow-hidden bg-[#F8FAFC] hover:shadow-xl transition-all duration-500 cursor-pointer"
            >
              <div className="w-full h-52 overflow-hidden">
                <img
                  src={industry.image}
                  alt={industry.title}
                  className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-700"
                />
              </div>
              <div className="p-7">
                <div className="w-10 h-10 flex items-center justify-center mb-4 bg-[#2563EB]/10 rounded-xl">
                  <i className={`${industry.icon} text-xl text-[#2563EB]`}></i>
                </div>
                <h3 className="text-xl font-bold text-[#0B1C2D] mb-2">
                  {industry.title}
                </h3>
                <p className="text-base text-gray-500 leading-relaxed">
                  {industry.description}
                </p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
